import React, { useState, useEffect } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import AssignmentIcon from '@mui/icons-material/Assignment';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import assortmentdetails from "../../../../assests/assortmentdetails.svg";
import assortmentRule from "../../../../assests/assortmentRule.svg";
import assortment from "../../../../assests/assortment.svg";
import assortmentvandingmachine from "../../../../assests/assortmentvendingmachine.svg";
import "./WarehouseAssortmentCreationComponent.css";
import { useNavigate, useParams } from "react-router-dom";
import { Divider, Typography } from "@mui/material";
import rulefailicon from "../../../../assests/rulefailicon.svg";
import morningbreakfasticon from "../../../../assests/morning-breakfast-items.svg";
import foractive from "../../../../assests/foractive.svg";
import forschdule from "../../../../assests/forschdule.svg";
import LoadingSpinner from "../../../Loading/component";
import eye from "../../../../assests/mingcute_eye.svg";
import eyeicon from "../../../../assests/refillEye.svg";
import scheduledRule from "../../../../assests/scheduledRule.svg"
import inactiveRule from "../../../../assests/inactiveRule.svg"
import activeRule from "../../../../assests/activeRule.svg"
import cross from "../../../../assests/cross.svg"



const WarehouseAssortmentCreationComponent = (props) => {
  const navigate = useNavigate();
  const { reference_id, assortmentId, ruleId } = useParams();
  const [selectedTab, setSelectedTab] = useState("assortments");
  const [userRole, setUserRole] = useState("");
  const [warehouseData, setWarehouseData] = useState({
    assortments: [],
    rules: [],
    machines: []
  });

  const [searchTerm, setSearchTerm] = useState("");

  // Filter machines based on search term (name or id)
  const filteredMachines = props.assortmentWarehouseMachinesDetailsList
    ?.find((h) => h.hardwareTypeId === props.selectedHardwareType)
    ?.machineDetails.filter(machine =>
      machine.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      machine.id.toString().includes(searchTerm)
    ) || [];



  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    if (props.onTabChange) {
      props.onTabChange(tab);
    }
  };
  const handleAssortmentDetails = (assortmentId) => {
    navigate(`/home/assortment/assortmentdetails/${assortmentId}`);
  };
  const handleAssortmentRuleRemove = (ruleId) => {
    navigate(`/home/assortment/assortmentdetails/${ruleId}`);
  };
  const handleAssortmentRuleDetails = (ruleId) => {
    navigate(`/home/assortment/assortmentdetails/${ruleId}`);
  };


  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("data"));
    if (userData) {
      setUserRole(userData.details.userRole.role_name);
    }
  }, []);


  const renderTabContent = () => {
    switch (selectedTab) {
      case "assortments":
        return (
          <div className="warehouse-assortment-table-section">
            <div className="warehouse-assortment-table-header">
              <div className="warehouse-assortment-table-title">
                <img src={assortment} alt="asrt" className="table-icon" />
                <span>Assortment</span>
              </div>
              {(userRole === "Admin" || userRole === "EST") && (
                <button className="warehouse-assortment-create-btn" onClick={props.onCreateNewAssortment}>
                  + Create New
                </button>
              )}
            </div>

            {/* Active Assortment */}
            <div className="assortment-section active-section">
              <div className="assortment-section-header">
                <h3 className="assortment-status-title">Active</h3>
              </div>

              {props.assortmentWarehouseMetaDataDetailsList?.active?.length > 0 ? (
                props.assortmentWarehouseMetaDataDetailsList.active.map((item, index) => (

                  <div className="active-assortment-card">
                    <div className="assortment-image-container">
                      <img
                        src={morningbreakfasticon}
                        alt="Assortment"
                        className="assortment-image"
                      />
                      <Typography>{item.itemCount} items</Typography>
                    </div>
                    <div className="assortment-content">
                      <div className="assortment-card-header">
                        <strong>Assortment Id: {item.assortmentId}</strong>
                      </div>
                      <div className="assortment-details">
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img src={foractive} alt="" />
                          <p>Start Date {item.startDate}</p>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img src={rulefailicon} alt="" />
                          <p>{item.ruleFailCount} Rule Fail</p>
                        </div>
                        <div className="assortment-actions">
                          {(userRole === "Admin" || userRole === "EST" || userRole === "Manager" || userRole === "city lead") && (
                          <img className="view-button" src={eyeicon} onClick={() => handleAssortmentDetails(item.assortmentId)} alt="" />
                           )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center" }}>
                  No active assortments found
                </div>
              )}
            </div>

            <div className="assortment-section scheduled-section">
              <div className="assortment-section-header">
                <h3 className="assortment-status-title">Schedule</h3>
              </div>

              {props.assortmentWarehouseMetaDataDetailsList?.scheduled?.length > 0 ? (
                props.assortmentWarehouseMetaDataDetailsList.scheduled.map((item, index) => (


                  <div className="assortment-card">
                    <div className="assortment-image-container">
                      <img
                        src={morningbreakfasticon}
                        alt="Assortment"
                        className="assortment-image"
                      />
                      <Typography>{item.itemCount} items</Typography>
                    </div>
                    <div style={{ height: "33px", color: "blue" }}></div>
                    <div className="assortment-content">
                      <div className="assortment-card-header">
                        <strong>Assortment Id: {item.assortmentId}</strong>
                      </div>
                      <div className="assortment-details">
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img src={forschdule} alt="" />
                          <p>Start Date {item.startDate}</p>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img src={rulefailicon} alt="" />
                          <p>{item.ruleFailCount} Rule Fail</p>
                        </div>
                        <div className="assortment-actions">
                            {(userRole === "Admin" || userRole === "EST" || userRole === "Manager" || userRole === "city lead") && (
                          <img onClick={() => handleAssortmentDetails(item.assortmentId)} className="view-button" src={eyeicon} alt="" />
                           )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center" }}>
                  No Schedule assortments found
                </div>
              )}
            </div>

            {/* Inactive Assortments */}
            <div className="assortment-section inactive-section">
              <div className="assortment-section-header">
                <h3 className="assortment-status-title">Inactive</h3>
              </div>

              {props.assortmentWarehouseMetaDataDetailsList?.inactive?.length > 0 ? (
                props.assortmentWarehouseMetaDataDetailsList.inactive.map((item, index) => (


                  <div className="assortment-card">
                    <div className="assortment-image-container">
                      <img
                        src={morningbreakfasticon}
                        alt="Assortment"
                        className="assortment-image"
                      />
                      <Typography>{item.itemCount} items</Typography>
                    </div>
                    <div className="assortment-content">
                      <div className="assortment-card-header">
                        <strong>Assortment Id: {item.assortmentId} </strong>
                      </div>
                      <div className="assortment-details">
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img src={forschdule} alt="" />
                          <p>Start Date {item.startDate}</p>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img src={rulefailicon} alt="" />
                          <p> End Date{item.endDate}</p>
                        </div>
                        <div className="assortment-actions">
                          {(userRole === "Admin" || userRole === "EST" || userRole === "Manager" || userRole === "city lead") && (
                          <img onClick={() => handleAssortmentDetails(item.assortmentId)} className="view-button" src={eyeicon} alt="" />
                           )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center" }}>
                  No inactive assortments found
                </div>
              )}
            </div>
          </div>
        );

      case "rules":
        return (
          <div className="warehouse-assortment-table-section">
            <div className="warehouse-assortment-table-header">
              <div className="warehouse-assortment-table-title">
                <img src={assortmentRule} alt="rules" className="table-icon" />
                <span>Rules</span>
              </div>
              {(userRole === "Admin" || userRole === "EST") && (
                <button className="warehouse-assortment-create-btn" onClick={props.onCreateNewRule}>
                  + Create New
                </button>
              )}
            </div>

            {/* Active Rules */}
            <div className="assortment-section active-section">
              <div className="assortment-section-header">
                <h3 className="assortment-status-title">Active</h3>
              </div>
              <div className="rules-table-container">
                <table className="rules-table">
                  <thead>
                    <tr>
                      <th>Rule ID</th>
                      <th>Start Date</th>
                      <th>Rule Type</th>
                      <th></th>
                      <th>Details</th>
                      <th>Slot</th>
                      <th className="actions-column">Actions</th>
                    </tr>
                  </thead>
                  <tbody>

                    {props.assortmentWarehouseMetaDataRuleDetailsList?.active?.length > 0 ? (
                      props.assortmentWarehouseMetaDataRuleDetailsList.active.map((rule, index) => (


                        <tr key={`active-rule-${index}`} className="active-rule-row">
                          <td>{rule.ruleId}</td>
                          <td>{rule.startDate}</td>
                          
                          <td>{rule.ruleType}</td>
                          
                          <td>
                            {rule.ruleType === "Offer Price" && (
                              <span>Price: Rs.{rule.maxOfferPrice}</span>
                            )}
                            {(rule.ruleType === "Product" || rule.ruleType === "Brand" || rule.ruleType === "Variant") && (
                              <span>{rule.ruleType} ID: {rule.ruleTypeIds}</span>
                            )}
                          </td>
                            <td>{rule.ruleTypeIds}</td>
                          <td>
                            {rule.value && (
                              <span>{rule.value}</span>
                            )}
                          </td>
                          <td className="actions-cell">
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                marginLeft: "10px"
                              }}
                              onClick={() => props.onAssortmentRuleRemove(rule.ruleId)}
                            >
                              {(userRole === "Admin" || userRole === "EST" ) && (
                              <img src={cross} alt="Remove" />
                               )}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        No active rule found
                      </div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Scheduled Rules */}
            <div className="assortment-section scheduled-section">
              <div className="assortment-section-header">
                <h3 className="assortment-status-title">Scheduled</h3>
              </div>
              <div className="rules-table-container">

                <table className="rules-table">
                  <thead>
                    <tr>

                      <th>Rule ID</th>
                      <th>Start Date</th>
                      <th>Rule Type</th>
                      <th></th>
                      <th>Details</th>
                      <th>Slot</th>

                      <th className="actions-column">Actions</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {props.assortmentWarehouseMetaDataRuleDetailsList?.scheduled?.length > 0 ? (
                      props.assortmentWarehouseMetaDataRuleDetailsList.scheduled.map((rule, index) => (



                        <tr key={`scheduled-rule-${index}`} className="scheduled-rule-row">

                          <td>{rule.ruleId}</td>
                          <td>{rule.startDate}</td>
                          <td>{rule.ruleType}</td>
                           
                          <td>
                            {rule.ruleType === "Offer Price" && (
                              <span>Price: Rs.{rule.maxOfferPrice}</span>
                            )}
                            {(rule.ruleType === "Product" || rule.ruleType === "Brand" || rule.ruleType === "Variant") && (
                              <span>{rule.ruleType} ID: {rule.ruleTypeIds}</span>
                            )}
                          </td>
                           <td>{rule.ruleTypeIds}</td>
                          <td>
                            {rule.value && (
                              <span>{rule.value} {rule.slot === "00" ? "(Restricted)" : ""}</span>
                            )}
                          </td>
                          <td className="actions-cell">
                            <button
                              style={{
                                background: "none",
                                border: "none",

                              }}
                              // className="table-action-button view-button"
                              onClick={() => props.handleCreateNewRuleUpdate(rule.ruleId)}
                            >
                              {(userRole === "Admin" || userRole === "EST" || userRole === "Manager" || userRole === "city lead") && (
                              <img src={eyeicon} alt="View" />
                              )}
                            </button>
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                marginLeft: "10px"
                              }}
                              onClick={() => props.onAssortmentRuleRemove(rule.ruleId)}
                            >
                             {(userRole === "Admin" || userRole === "EST") && (
                              <img src={cross} alt="Remove" />
                               )}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        No scheduled rule found
                      </div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Inactive Rules */}
            <div className="assortment-section inactive-section">
              <div className="assortment-section-header">
                <h3 className="assortment-status-title">Inactive</h3>
              </div>
              <div className="rules-table-container">
                <table className="rules-table">
                  <thead>
                    <tr>
                      <th>Rule ID</th>
                      <th>Start Date</th>
                      <th>Rule Type</th>
                      <th></th>
                      <th>Details</th>
                      <th>Slot</th>
                    </tr>
                  </thead>
                  <tbody>


                    {props.assortmentWarehouseMetaDataRuleDetailsList?.inactive?.length > 0 ? (
                      props.assortmentWarehouseMetaDataRuleDetailsList.inactive.map((rule, index) => (


                        <tr key={`inactive-rule-${index}`} className="inactive-rule-row">
                          <td>{rule.ruleId}</td>
                          <td>{rule.startDate}</td>
                          <td>{rule.ruleType}</td>
                          <td>
                            {rule.ruleType === "Offer Price" && (
                              <span>Price: Rs.{rule.maxOfferPrice}</span>
                            )}
                            {(rule.ruleType === "Product" || rule.ruleType === "Brand" || rule.ruleType === "Variant") && (
                              <span>{rule.ruleType} ID: {rule.ruleTypeIds}</span>
                            )}
                          </td>
                           <td>{rule.ruleTypeIds}</td>
                          <td>
                            {rule.value && (
                              <span>{rule.value}</span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        No inactive rule found
                      </div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );

      case "machines":

        return (
          <div className="warehouse-assortment-table-section">
            {/* <div className="warehouse-assortment-table-header">
        <div className="warehouse-assortment-table-title">
          <img src={assortmentvandingmachine} alt="machines" className="table-icon" />
          <span>Machines</span>
        </div>
        {userRole === "Admin" && (
          <button className="warehouse-assortment-create-btn" onClick={props.handleCreateNewMachine}>
            + Create New
          </button>
        )}
      </div> */}

            {/* Hardware Type Tabs */}
            <div className="hardware-type-tabs">
              {props.assortmentWarehouseMachinesDetailsList?.map((hardwareType) => (
                <div
                  key={hardwareType.hardwareTypeId}
                  className={`hardware-type-tab ${props.selectedHardwareType === hardwareType.hardwareTypeId ? "active" : ""
                    }`}
                  onClick={() => props.setSelectedHardwareType(hardwareType.hardwareTypeId)}
                >
                  <div className="hardware-type-name">{hardwareType.hardwareTypeName}</div>
                  <div className="hardware-type-count">{hardwareType.machineDetails.length}</div>
                </div>
              ))}
              {console.log("hardware", props.assortmentWarehouseMachinesDetailsList)}
            </div>

            {/* VM List Header with Search */}
            <div className="vm-list-header">
              <h3 className="vm-list-title">VM List</h3>
              <div className="vm-search-container">
                <input
                  type="text"
                  placeholder="Search by name or ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="vm-search-input"
                />
                <span className="search-icon">🔍</span>
              </div>
            </div>

            {/* VM List Table */}
            <div className="vm-table-container">
              <table className="vm-table">
                <thead>
                  <tr>
                    <th className="vm-number-col">#</th>
                    <th className="vm-name-col">Machine Name</th>
                    <th className="vm-id-col">ID</th>
                    {/* <th className="vm-actions-col">Actions</th> */}
                  </tr>
                </thead>
                <tbody>
                  {filteredMachines.map((machine, index) => (
                    <tr key={machine.id} className="vm-table-row">
                      <td className="vm-number">{index + 1}</td>
                      <td className="vm-name">{machine.name}</td>
                      <td className="vm-id">{machine.id}</td>
                      {/* <td className="vm-actions">
                  <button 
                    className="vm-delete-btn"
                    onClick={() => console.log('Delete machine', machine.id)}
                    title="Delete machine"
                  >
                    <img src={cross} alt="Delete" className="delete-icon" />
                  </button>
                </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
              {filteredMachines.length === 0 && (
                <div className="vm-empty-state">
                  No machines found matching your search
                </div>
              )}
            </div>
          </div>
        );


      default:
        return null;
    }
  };


  const EndRuleConfirmationModal = () => {
    const today = new Date().toISOString().split("T")[0]; // Ensure min date works

    if (!props.showEndRuleModal) return null;

    return (
      <div className="modal-rule-overlay">
        <div className="modal-rule-container">
          <div className="modal-rule-header">
            <h3>Are You Sure You Want To End This Rule?</h3>
          </div>
          <div className="modal-rule-body">
            <div className="form-rule-group">
              <label>Select End Date</label>
              <input
                type="date"
                value={props.endDate}
                onChange={(e) => props.onEndDateChange(e.target.value)}
                className="date-rule-input"
                min={today}
              />
            </div>
          </div>
          <div className="modal-rule-footer">
            <button
              className="cancel-rule-button"
              onClick={props.onCloseEndRuleModal}
            >
              Cancel
            </button>
            <button
              className="confirm-rule-button"
              onClick={props.onEndRuleConfirm}
              disabled={!props.endDate}

            >
              End
            </button>

          </div>
        </div>
      </div>

    );
  };

  return (
    <>
      {props && props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="warehouse-assortment-layout">
          <Sidebar />
          <div className="warehouse-assortment-content">

            <div className="warehouse-assortment-header">
              <button className="warehouse-assortment-back-btn" onClick={() => navigate(-1)}>
                ←
              </button>
              <h2 className="warehouse-assortment-title">{props.assortmentWarehouseMetaDataDetails && props.assortmentWarehouseMetaDataDetails.reference_name}</h2>
            </div>


            <div className="warehouse-assortment-tabs">
              <div
                className={`warehouse-assortment-tab-card ${selectedTab === "assortments" ? "active" : ""}`}
                onClick={() => setSelectedTab("assortments")}
              >
                <div className="tab-card-top">
                  <span>Assortments</span>
                  <img src={assortmentdetails} alt="" />
                </div>
                <div className="tab-card-bottom">
                  <h3>{props.assortmentWarehouseMetaDataDetails && props.assortmentWarehouseMetaDataDetails.total_assortments}</h3>
                </div>
              </div>

              <div
                className={`warehouse-assortment-tab-card ${selectedTab === "rules" ? "active" : ""}`}
                onClick={() => handleTabChange("rules")}
              >
                <div className="tab-card-top">
                  <span>Rules</span>
                  <img src={assortmentRule} alt="" />
                </div>
                <div className="tab-card-bottom">
                  <h3>{props.assortmentWarehouseMetaDataDetails && props.assortmentWarehouseMetaDataDetails.total_rules}</h3>
                </div>
              </div>

              <div
                className={`warehouse-assortment-tab-card ${selectedTab === "machines" ? "active" : ""}`}
                onClick={() => setSelectedTab("machines")}
              >
                <div className="tab-card-top">
                  <span>Machines</span>
                  <img src={assortmentvandingmachine} alt="" />
                </div>
                <div className="tab-card-bottom">
                  <h3>{props.assortmentWarehouseMetaDataDetails && props.assortmentWarehouseMetaDataDetails.total_machines}</h3>
                </div>
              </div>
            </div>

            {renderTabContent()}
          </div>
        </div>
      )}
      <EndRuleConfirmationModal />
    </>
  );
};

export default WarehouseAssortmentCreationComponent;